import { Trans } from '@lingui/react/macro';
import { MoneyRecord, SalesItemRecord, TireQuoteItemTireRecordCustomer } from '@navio/nsdk';
import { formatCurrencyAmount, getTirePrice } from 'noddi-util';
import { getTireOfferTiresTotal, getTireOfferTotal } from './tireOfferTotal';
import { TirePriceSummary } from './TirePriceSummary';

interface TireOfferPaymentSummaryProps {
  quoteItemTires: TireQuoteItemTireRecordCustomer[];
  genericItems: SalesItemRecord[];
  isStaggered: boolean;
}

export const TireOfferPaymentSummary = ({
  quoteItemTires,
  genericItems,
  isStaggered
}: TireOfferPaymentSummaryProps) => {
  const totalTireSum = getTireOfferTiresTotal(quoteItemTires);
  const totalSum = getTireOfferTotal(quoteItemTires, genericItems);
  const totalQuantity = quoteItemTires.reduce((sum, quoteItemTire) => sum + (quoteItemTire.quantitySelected ?? 0), 0);

  const firstTire: TireQuoteItemTireRecordCustomer | undefined = quoteItemTires[0];
  const collapsedLineGross: MoneyRecord | undefined = firstTire
    ? { amount: totalTireSum, currency: getTirePrice(firstTire).currency }
    : undefined;

  return (
    <div className='flex flex-col gap-2'>
      {isStaggered
        ? quoteItemTires.map((quoteItemTire) => {
            const unitGross: MoneyRecord = getTirePrice(quoteItemTire);
            const quantity: number = quoteItemTire.quantitySelected ?? 0;
            const lineGross: MoneyRecord = { amount: unitGross.amount * quantity, currency: unitGross.currency };
            return (
              <TirePriceSummary key={quoteItemTire.id} tire={quoteItemTire} quantity={quantity} lineGross={lineGross} />
            );
          })
        : firstTire &&
          collapsedLineGross && (
            <TirePriceSummary tire={firstTire} quantity={totalQuantity} lineGross={collapsedLineGross} />
          )}

      {genericItems.map(({ name, price, id }) => (
        <div className='flex justify-between gap-4' key={id}>
          <p>{name}</p>
          <p>
            {formatCurrencyAmount({
              money: { amount: price.priceGross.amount, currency: price.priceGross.currency }
            })}
          </p>
        </div>
      ))}

      <div className='border-t font-semibold'>
        <div className='mt-2 flex justify-between gap-2'>
          <p>
            <Trans>Total sum including VAT</Trans>
          </p>
          <p>
            {formatCurrencyAmount({
              money: { amount: totalSum }
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
